<template>
  <div>
    <div class="d-flex align-center justify-space-between pa-2">
      <h2 class="flex-1">Registros</h2>
      <v-btn text @click="goBack">
        <v-icon left>mdi-chevron-left</v-icon>
        Voltar
      </v-btn>
    </div>
    <!-- min-height="calc(100vh - 138px)" -->

    <TableLogs
      v-if="view === 'table'"
      :loading="loading"
      :logs="filteredLogs"
      :fullLoaded="fullLoaded"
      @loadMore="loadMore"
    />
    <!-- <ListView
        v-else-if="view === 'list'"
        :loading="loading"
        :logs="filteredLogs"
        :fullLoaded="fullLoaded"
        @loadMore="loadMore"
      />
      <CalendarView
        v-else
        :logs="filteredLogs"
        :view="view"
        :viewsMap="viewsMap"
        :interval="interval"
        style="flex-grow: 1"
        @dayClick="dayClick"
      /> -->
    <ImageViewer />
  </div>
</template>

<script>
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
dayjs.locale("pt-br");
import { mapGetters } from "vuex";
import STORE from "@/services/store";
import TableLogs from "../../components/logs/TableLogs.vue";
import ImageViewer from "../../components/global/ImageViewer.vue";

export default {
  name: "Logs",
  components: {
    TableLogs,
    ImageViewer,
  },
  data() {
    return {
      date: new Date(),
      view: "table",
      loading: false,
      logs: new Set(),
      logsList: [],
      fullLoaded: false,
    };
  },

  methods: {
    goBack() {
      this.$router.back();
    },
    loadMore(options = {}) {
      this.getLogs(options);
    },
    async getLogs({ start, end, accessId, skip } = {}) {
      try {
        if (this.loading) return;
        this.loading = true;
        const storeId = this.selectedStore.id;

        var query = {};

        if (start) query.start = start;
        if (end) query.end = end;
        if (accessId) query.accessId = accessId;
        if (skip) query.skip = skip;

        const response = await STORE.getLogs(storeId, {
          params: query,
        });
        for (const log of response.logs) {
          if (!this.logs.has(log.id)) {
            this.logsList.push(log);
            this.logs.add(log.id);
          }
        }
      } catch (error) {
        // this.$toast.error("Erro ao buscar logs");
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    ...mapGetters("store", ["selectedStore"]),
    filteredLogs() {
      if (!this.selectedClient) return this.logsList;
      return this.logsList.filter(
        (log) => log.accessId === this.selectedClient.accessId
      );
    },
  },
  watch: {
    date: {
      handler() {
        this.$nextTick(() => {
          this.getLogs();
        });
      },
      deep: true,
    },
    selectedClient: {
      handler(value) {
        this.skip = 0;
        if (this.view === "list") this.getLogs();
      },
      immediate: true,
    },
    // selectedStore: {
    //   handler(value, oldValue) {
    //     if (value?.id !== oldValue?.id) {
    //       this.skip = 0;
    //       this.logsList = [];
    //       this.logs = new Set();
    //       this.getLogs();
    //     }
    //   },
    //   immediate: true,
    // },
  },
  mounted() {
    // this.getLogs();
  },
};
</script>

<style lang="scss">
$calendar-event-line-height: 24px;
</style>
